<template>
	<!-- Swiper6之前默认容器是'.swiper-container' -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div
                v-for="(item, index) in arr"
                :key="index"
                class="swiper-slide"
            >
                <video
                v-if="item.type == 'mp4' || item.type == 'mov'"
                :src="item.url"
                controls="controls"
                :autoplay="false"
                ></video>
                <img
                v-else-if="
                    item.type == 'jpg' ||
                    item.type == 'png' ||
                    item.type == 'jpeg' ||
                    item.type == 'svg' ||
                    item.type == 'webp' ||
                    item.type == 'jfif'
                "
                :src="item.url"
                alt=""
                />
            </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
</template>

<script>
    //引用swiper
    import Swiper from "swiper";
    //引用swiper样式
   	import 'swiper/swiper-bundle.css';
    
    export default {
        data(){
            return{
                arr :[
    {
        "url": "https://test.b-chem.com/static/th-upload//20220825/889d9402132e46bc883d63e675333ef3.png",
        "id": 44,
        "name": "图片7.png",
        "type": "png",
        "uid": 1661395949118,
        "status": "success"
    },
    {
        "url": "https://test.b-chem.com/static/th-upload//20220825/3196b02c226e4ef9ba95b367407cbb78.png",
        "id": 53,
        "name": "微信图片_54.png",
        "type": "png",
        "uid": 1661414330886,
        "status": "success"
    },
    {
        "url": "https://test.b-chem.com/static/th-upload//20220825/15b1871cf15c46fbab8bc08cc7d73652.png",
        "id": 54,
        "name": "微信图片_54.png",
        "type": "png",
        "uid": 1661414339697,
        "status": "success"
    },
    {
        "url": "https://test.b-chem.com/static/th-upload//20220825/3445515cef014a4da74ad18bc5170a79.png",
        "id": 46,
        "name": "图片6.png",
        "type": "png",
        "uid": 1661396045243,
        "status": "success"
    },
    {
        "url": "https://test.b-chem.com/static/th-upload//20220826/7f45a95570714d3689b84a9f75072dd8.jpg",
        "id": 55,
        "name": "aaa.jpg",
        "type": "jpg",
        "uid": 1661476400235,
        "status": "success"
    },
    {
        "url": "https://test.b-chem.com/static/th-upload//20220826/6f46698bd5464e41b42989637fa63b21.jpg",
        "id": 57,
        "name": "73b6f1a9528a42861676fdcdbb56264.jpg",
        "type": "jpg",
        "uid": 1661476824771,
        "status": "success"
    },
    {
        "url": "https://test.b-chem.com/static/th-upload//20220825/572c603501924b439460aab03713ab63.png",
        "id": 42,
        "name": "图片8.png",
        "type": "png",
        "uid": 1661395892027,
        "status": "success"
    }
]
            }
        },
    	mounted() {
    	    //组件挂载完毕后初始化Swiper
            this.getSwiper();
        },
        methods:{
            getSwiper(){
                var mySwiper = new Swiper('.swiper-container', {
                    //direction: 'vertical', 垂直切换选项
                    autoplay:{
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: true,
                    },
                    loop: true, // 开启循环模式选项
                    slidesPerView: 2,
                    spaceBetween: 30,
                    // 如果需要分页器
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,  //点分页时可以切换
                    },

                    // 如果需要前进后退按钮
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                })
            }
        },
    }
</script>

<style scoped>
    .swiper-container{
        position: relative;
        height: 9rem;
        overflow: hidden;
    }
    .swiper-button-prev,
    .swiper-button-next {
        width: 56px;
        height: 56px;
        /* background: #9999;
        border-radius: 50%; */
        font-size: 16px;
        /* color: #ffff; */
    }
    .swiper-pagination{
        width: 100px;
        height: 40px;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }
      .swiper-slide video {
  width: 16rem;
  height: 9rem;
}
.swiper-slide img {
  display: block;
  width: 16rem;
  height: 9rem;
}
</style>